export default __webpack_public_path__ + "static/media/app-details.aaf61aa1.png";